const DIAS_A_VENCER = 15;

export function statusParcela(statusApi, dataVencimento, hoje = new Date()) {
  if (statusApi === "BAIXADO") {
    return "Pago";
  }

  const vencimento = new Date(dataVencimento);
  const limiteAVencer = new Date(hoje);
  limiteAVencer.setDate(hoje.getDate() + DIAS_A_VENCER);

  if (vencimento < hoje) {
    return "Vencido";
  }
  if (vencimento <= limiteAVencer) {
    return "A Vencer";
  }
  return "Em Aberto";
}
